import * as Sentry from '@sentry/vue';
import commonOptions from './common-options';

export default function sentryInitVue(options = {}) {
  Sentry.init({
    ...options,
    ...commonOptions,
    logErrors: true,
  });
}
